import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  VStack,
  Text,
} from "@chakra-ui/react";

interface PrivacyPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PrivacyPolicyModal: React.FC<PrivacyPolicyModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Privacy Policy</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <VStack spacing={4} align="start">
            <Text>
              This Privacy Policy outlines how we collect, use, and protect your
              personal information.
            </Text>

            <Text fontWeight="bold">1. Information We Collect</Text>
            <Text>
              We collect the following personal information that you provide:
            </Text>
            <Text as="ul" pl={6}>
              <li>Full Name</li>
              <li>Email Address</li>
              <li>Mobile Phone Number</li>
              <li>Job Title (optional)</li>
              <li>Company Name (optional)</li>
            </Text>

            <Text fontWeight="bold">2. Purpose of Collection</Text>
            <Text>Your information is used for:</Text>
            <Text as="ul" pl={6}>
              <li>Event Registration</li>
              <li>QR Code Generation</li>
              <li>Event Communications</li>
              <li>Service Improvement</li>
            </Text>

            <Text fontWeight="bold">3. Data Security</Text>
            <Text>
              We employ industry-standard security measures to protect your
              personal information from unauthorized access or disclosure.
            </Text>

            <Text fontWeight="bold">4. Your Privacy Rights</Text>
            <Text>You have the right to:</Text>
            <Text as="ul" pl={6}>
              <li>Access your personal information</li>
              <li>Request corrections to your data</li>
              <li>Request deletion of your information</li>
              <li>Withdraw your consent</li>
            </Text>

            <Text fontWeight="bold">5. Contact Information</Text>
            <Text>
              For privacy-related inquiries, please contact us at
              support@sociallab.co.th
            </Text>
            <Text>Version 1.0.4</Text>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
